module.exports = __webpack_public_path__ + "static/img/Goat.4e69358.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/cz_animal/Goat.svg
// module id = 1360
// module chunks = 0